<template>
  <div>
    <h6 class="title">Olá {{ businessName }}</h6>
    Agradecemos seu interesse em revender os nossos produtos. Seu cadastro foi
    recebido com sucesso.
    <br />
    {{
      type === 'riffel'
        ? 'Em breve você será atendido pela nossa equipe comercial.'
        : 'Em breve um dos nossos distribuidores parceiros, entrará em contato para realizar seu atendimento.'
    }}
    <br />
    <br />
    Fique atento!
    <br />
    Vá mais longe. Vá com Riffel.
  </div>
</template>

<script>
export default {
  name: 'message-result',
  props: {
    businessName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'riffel',
    },
  },
};
</script>
